import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";
import { NationalAccountInfoPayload } from "../stores/slices/nationalAccountInfoSlice";
import { isNationalReferrer } from "../util/isNationalReferrer";

export const useGetNationalAccountInfoByNationalAccountUrlCode =
  (): ModifiedSWRResponse<
    FetcherResult<NationalAccountInfoPayload>,
    NationalAccountInfoPayload
  > => {
    const dealer = useNullableDealerAccountInfo();
    const shouldFetch = Boolean(dealer?.dealerId && isNationalReferrer());

    const result = useSwrGet<NationalAccountInfoPayload>(
      shouldFetch
        ? "/retailSiteWebService/national/getNationalAccountInfoByNationalAccountUrlCode.php"
        : null,
      shouldFetch
        ? {
            nationalAccountCode: dealer?.dealerNationalAccountName ?? "",
          }
        : {}
    );

    return result;
  };
